// extracted by mini-css-extract-plugin
export default {"wrapper":"Rating_wrapper_YmQQ3","disabled":"Rating_disabled_fUuQc","item":"Rating_item_iY9Rv","colored":"Rating_colored_yeSfb"};